module.exports = __webpack_public_path__ + "static/019.thumb-9f0a077a955f7ac7948a3aebba80855e.jpg";